const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLForm = require('app/graphql/Form');


const ProductTempCreateModal = require('app/restaurant/analyse/product/TempCreateModal')

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurantProspectAnalyseInvoice',
            'analyse': null,
            'invoice': null,

            'modal': null,
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.onSubmit = this.onSubmit.bind(this);
        this.onClickAddProduct = this.onClickAddProduct.bind(this);
        this.onChangeSupplier = this.onChangeSupplier.bind(this);

        this.analyse = this.settings.analyse;
        this.invoice = this.settings.invoice;

        if(this.invoice){
            this.mode = 'edit';
        }else{
            this.mode = 'create';
        }

        this.products = [];
        this.changed = false;
        this.openAddProductRequested = false;

        this.buildForm();
        super.initialize();
    }

    loadData(){
        var self = this;

        this.$form
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildProspectSupplierQuery(),
            this.buildSupplierQuery(),
            this.buildSupplierRangeQuery(),
            this.buildProductUnitsQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildProspectSupplierQuery(){
        var self = this;

        let parameters = {
            'orderBy': 'name',
            'dir': 'ASC',
            'first': 1000000,
        };

        let fields = [
            'id',
            'name'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantProspectSuppliers',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildSupplierQuery(){
        var self = this;

        let parameters = {
            'orderBy': 'name',
            'dir': 'ASC',
            'first': 1000000,
            'filter':{
                'enable': true
            }
        };

        let fields = [
            'id',
            'name'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'suppliers',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildSupplierRangeQuery(){
        var self = this;

        let parameters = {
            'orderBy': 'name',
            'dir': 'ASC',
            'first': 1000000,
        };

        let fields = [
            'id',
            'name'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductRanges',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildProductUnitsQuery(){
        var self = this;

        let parameters = {
        };

        let fields = [
            'value',
            'label'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductUnits',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;

    }

    getAnalyse(){
        return this.analyse;
    }

    getProductAssociation(){
        return this.productAssociation;
    }

    getForm(){
        return this.$form;
    }

    hasUnsubmittedData(){
        return this.changed;
    }

    isBtnAddRequested(){
        return this.openAddProductRequested;
    }

    buildForm(){
        var self = this;


        this.$form = $('<form/>')
        .addClass('restaurant-analyse-invoice-form');

        this.loadData();

        return this.$form;
    }

    fillForm(data){

        this.prospectSuppliers = data.restaurantProspectSuppliers.edges;
        this.suppliers = data.suppliers.edges;
        this.ranges = data.supplierProductRanges.edges;
        this.units = data.supplierProductUnits;

        this.$form.html('');

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append("Enregistrer la saisie");

        this.$selectSupplier = $('<select/>')
        .attr('id',"supplierId")
        .attr('name',"supplier[id]")
        .addClass("form-control")
        .on('change',this.onChangeSupplier);


        this.$selectSupplier
        .append(
            $('<option/>')
            .val(0)
            .append(window.translate('app.restaurant.show.tabs.analyse.invoice.create.supplier.create.label'))
        );
        for(var i in this.prospectSuppliers){
            let supplier = this.prospectSuppliers[i].node;

            this.$selectSupplier
            .append(
                $('<option/>')
                .val(supplier.id)
                .append(supplier.name)
            )
        }

        this.$inputSupplierName = $('<input/>')
        .attr('type','text')
        .attr('id','supplierName')
        .attr('name','supplier[name]')
        .attr('required','required')
        .attr('placeholder',window.translate('app.restaurant.show.tabs.analyse.invoice.create.supplier.placeholder'))
        .addClass('form-control');

        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','supplierId')
                .append(window.translate('app.restaurant.show.tabs.analyse.invoice.create.supplier.label'))
            )
            .append(this.$selectSupplier)
            .append(this.$inputSupplierName)
        );

        let orderedAt = window.formatDate(this.analyse.analysePeriodBegin,'YYYY-MM-DD');
        this.$inputOrderedAt = $('<input/>')
        .attr('type','date')
        .addClass('form-control')
        .attr('id',"orderedAt")
        .attr('name','orderedAt')
        .val(orderedAt);

        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','orderedAt')
                .append(window.translate('app.restaurant.show.tabs.analyse.invoice.create.orderedAt.label'))
            )
            .append(this.$inputOrderedAt)
        );

        this.$form.append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append(this.$btnSubmit.clone())
        );

        this.$form.append(this.buildProductContainer());


        this.$form.append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append(this.$btnSubmit)
        );

        window.select2(this.$selectSupplier);
    }

    buildProductContainer(){
        this.$productContainer = $('<div/>')
        .addClass('mt-2')
        .addClass('restaurant-analyse-invoice-product-container white-box');


        this.$productContainer
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center')
            .append(
                $('<h4/>')
                .append(window.translate('restaurant.prospect.invoice.productAssociation.label'))
            )
        )

        this.$productTable = $('<table/>')
        .addClass('table table-striped')
        .append(
            $('<thead/>')
            .append(
                $('<tr/>')
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.product.reference.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.prospect.product.packaging.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.prospect.invoice.productAssociation.quantity.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.product.price.label'))
                )
                .append(
                    $('<th/>')
                    .append('')
                )
            )
        )
        .appendTo(this.$productContainer);

        this.$productTableBody = $('<tbody/>')
        .appendTo(this.$productTable);

        this.$btnAddProduct = $('<button/>')
        .addClass('btn btn-primary')
        .append(window.translate('app.restaurant.show.tabs.analyse.invoice.create.productAssociation.add.label'))
        .on('click',this.onClickAddProduct);

        this.$productTableBody.append(
            $('<tr/>')
            .addClass('restaurant-analyse-invoice-product-line-add')
            .append(
                $('<td/>')
                .attr('colspan', 5)
                .append(
                    $('<div/>')
                    .addClass('d-flex justify-content-center')
                    .append(this.$btnAddProduct)
                )
            )
        )

        return this.$productContainer;
    }

    onChangeSupplier(event){
        if(this.$selectSupplier.val() != 0){
            this.$inputSupplierName
            .removeAttr('required')
            .val('')
            .hide();
        }else{
            this.$inputSupplierName
            .attr('required','required')
            .show()
            .focus();
        }
    }

    isValid(){
        let isValid = super.isValid();

        if(this.products.length <= 0){
            isValid = false;
            this.$productContainer.addClass('border-danger');
            window.notify(window.translate('app.restaurant.show.tabs.analyse.invoice.create.error.noProduct'),"error")
        }

        return isValid;
    }

    onDOMReady(){
    }

    getFields(){
        let fields = super.getFields();
        //fields.push('productAssociation { id total price quantity orderedAt supplier { name } product { id reference unit quantity product { id quantity unit price supplier { name } } } }');
        return fields;
    }
    
    getVariables(){
        let variables = {};
        variables.analyse = {
            'value': this.analyse.id,
            'type': 'Int!'
        };
        return variables;
    }


    onSuccess(data){
        this.invoice = data.invoice;
        super.onSuccess(data);
    }

    onClickAddProduct(event){
        var self = this;
        event.stopPropagation();
        event.preventDefault();

        this.openAddProductRequested = true;

        if(this.settings.modal){
            this.settings.modal.hide();
        }

        this.createModal = new ProductTempCreateModal({
            'title': window.translate('app.restaurant.show.tabs.analyse.invoice.create.productAssociation.add.label'),
            'suppliers': this.suppliers,
            'ranges': this.ranges,
            'units': this.units,

            'onClose': function(event){
                self.openAddProductRequested = false;
                if(self.settings.modal){
                    self.settings.modal.show();
                }
            },
            'onSubmit': function(data){
                if(self.settings.modal){
                    self.settings.modal.show();
                }
                self.addProduct(data);
            }
        });
    }

    addProduct(data){
        this.changed = true;
        this.products.push(data);
        this.buildProductList();
    }

    buildProductList(){
        this.$productContainer.removeClass('border-danger');
        if(this.$form.hasClass('was-validated')){
            if(this.products.length <= 0){
                this.$productContainer.addClass('border-danger');
            }else{
                this.$productContainer.addClass('border-success');
            }
        }

        $('.restaurant-analyse-invoice-product',this.$productTableBody).remove();
        let $btnAddLine = $('.restaurant-analyse-invoice-product-line-add',this.$productTableBody);
        for(var index in this.products){
            let product = this.products[index];
            $btnAddLine.before(this.buildProductLine(index,product)); 
        }
    }

    buildProductLine(index,product){
        var self = this;
        let $line = $('<tr/>')
        .attr('data-index',index)
        .data('product',product)
        .addClass('restaurant-analyse-invoice-product');

        let $actions = $('<div/>');

        let $btnDelete = $("<button/>")
        .attr('data-index',index)
        .addClass('btn btn-text text-danger')
        .append(
            $('<i/>')
            .addClass('fas fa-trash')
        )
        .on('click',function(event){
            let $btn = $(this);
            self.onRemoveProduct($btn.data('index'));
        });

        $actions.append($btnDelete);

        $actions
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','productAssociations['+index+'][price]')
            .val(window.ensureFloatText(product.price))
        )
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','productAssociations['+index+'][quantity]')
            .val(window.ensureFloatText(product.quantity))
        )
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','productAssociations['+index+'][product][reference]')
            .val(product.reference)
        )
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','productAssociations['+index+'][product][quantity]')
            .val(window.ensureFloatText(product.productQuantity))
        )
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','productAssociations['+index+'][product][unit]')
            .val(product.productUnit)
        )
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','productAssociations['+index+'][product][product][id]')
            .val(product.linkedProduct)
        )

        $line
        .append(
            $('<td/>')
            .append(product.reference)
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(product.productQuantity) + ' ' + this.getUnitLabel(product.productUnit))
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(product.quantity))
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(product.price)+'&euro;')
        )
        .append(
            $('<td/>')
            .append($actions)
        )


        return $line;
    }

    onRemoveProduct(index){
        this.changed = true;
        this.products.splice(index,1);
        this.buildProductList();
    }

    getUnitLabel(value){
        for(var i in this.units){
            let unit = this.units[i];
            if(unit.value == value){
                return unit.label;
            }
        }
        return value;
    }
}



module.exports = Form;

